import { HStack, IconButton, Box, Button } from "@chakra-ui/react";
import CDS from "design-system";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import moment from "moment";

interface WeekNavigatorProps {
  startTime?: string;
  endTime?: string;
  onWeekChange: (startTime: string, endTime: string) => void;
}

export default function WeekNavigator({
  startTime = moment().startOf('week').format(),
  endTime = moment().endOf('week').format(),
  onWeekChange,
}: WeekNavigatorProps) {
  const handlePreviousWeek = () => {
    const newStart = moment(startTime).subtract(1, "week").startOf("week");
    const newEnd = moment(endTime).subtract(1, "week").endOf("week");
    onWeekChange(newStart.format(), newEnd.format());
  };

  const handleNextWeek = () => {
    const newStart = moment(startTime).add(1, "week").startOf("week");
    const newEnd = moment(endTime).add(1, "week").endOf("week");
    onWeekChange(newStart.format(), newEnd.format());
  };

  const handleCurrentWeek = () => {
    const currentStart = moment().startOf("week");
    const currentEnd = moment().endOf("week");
    onWeekChange(currentStart.format(), currentEnd.format());
  };

  const isCurrentWeek = () => {
    const currentStart = moment().startOf("week");
    const viewingStart = moment(startTime).startOf("week");
    return currentStart.isSame(viewingStart, "day");
  };

  const formatWeekRange = () => {
    const start = moment(startTime);
    const end = moment(endTime);
    const startMonth = start.format("MMM");
    const endMonth = end.format("MMM");

    // If the week spans two months
    if (startMonth !== endMonth) {
      return `${startMonth} ${start.format("D")} - ${endMonth} ${end.format("D")}`;
    }

    // If the week is within the same month
    return `${startMonth} ${start.format("D")} - ${end.format("D")}`;
  };

  return (
    <HStack spacing={2} justifyContent="center" alignItems="stretch">
      <Button
        isDisabled={isCurrentWeek()}
        onClick={handleCurrentWeek}
        size="sm"
        variant="outline"
      >
        Today
      </Button>
      <HStack spacing={1}>
        <IconButton
          aria-label="Previous week"
          icon={<ChevronLeftIcon />}
          onClick={handlePreviousWeek}
          size="sm"
          variant="outline"
        />
        <Box
          alignContent="center"
          minW="90px"
        >
          <CDS.Text12 fontWeight="medium" align="center">
            {formatWeekRange()}
          </CDS.Text12>
        </Box>
        <IconButton
          aria-label="Next week"
          icon={<ChevronRightIcon />}
          onClick={handleNextWeek}
          size="sm"
          variant="outline"
        />
      </HStack>
    </HStack>
  );
}
